(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("ontime-components", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["ontime-components"] = factory(require("react"), require("react-dom"));
	else
		root["ontime-components"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 